import './card-links.scss';

import 'slick-carousel';
import 'slick-carousel/slick/slick.scss';

import Component from '../../components/component/component';
import Helpers from '../../components/helpers/helpers';

interface ISlickInstance {
    currentSlide: number;
    slideCount: number;
    options: {
        slidesToShow: number;
    };
}

export default class CardLinks extends Component {
    static initSelector: string = '.card-links';

    private cardsWrapper: JQuery;
    private prevButton: JQuery;
    private nextButton: JQuery;
    private nav: JQuery;
    private slick: JQuery = $();

    constructor(target: HTMLElement) {
        super(target);

        this.cardsWrapper = this.element.find('.card-links__cards');
        this.prevButton = this.element.find('.card-links__nav-button--prev');
        this.nextButton = this.element.find('.card-links__nav-button--next');
        this.nav = this.element.find('.card-links__nav');

        $(document).ready(() => this.init());
    }

    init(): void {
        const carouselAttributes: JQuerySlickOptions = {
            arrows: false,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            rows: 0,
            responsive: [
                {
                    breakpoint: Helpers.bp.lg - 1,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: Helpers.bp.md - 1,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        };

        this.cardsWrapper.on('init', (event: JQuery.TriggeredEvent, slick: ISlickInstance) => {
            this.updateNavState(slick);
        });

        this.slick = this.cardsWrapper.slick(carouselAttributes);

        this.cardsWrapper.on('afterChange breakpoint', (event: JQuery.TriggeredEvent, slick: ISlickInstance) => {
            this.positionNav();
            this.updateNavState(slick);
        });

        // Re-position when card images finish loading, as their height affects the nav position
        this.element.find('.card-links__media img').on('load', this.positionNav.bind(this));

        $(window).on('resize', this.positionNav.bind(this));

        this.prevButton.on('click', this.onPrevClick.bind(this));
        this.nextButton.on('click', this.onNextClick.bind(this));

        this.positionNav();
    }

    updateNavState(slick: ISlickInstance): void {
        const slidesToShow: number = slick.options.slidesToShow;

        this.prevButton.toggleClass('is-disabled', slick.currentSlide === 0);
        this.nextButton.toggleClass('is-disabled', slick.currentSlide >= slick.slideCount - slidesToShow);
    }

    positionNav(): void {
        const wrapper: JQuery = this.element.find('.card-links__slider-wrapper');
        const media: JQuery = this.element.find('.card-links__media').first();

        const wrapperTop: number = wrapper.offset()?.top ?? 0;
        const mediaTop: number = media.offset()?.top ?? 0;
        const mediaCenter: number = mediaTop - wrapperTop + (media.outerHeight() ?? 0) / 2;

        this.nav.css('top', mediaCenter);
    }

    onPrevClick(): void {
        this.slick.slick('slickPrev');
    }

    onNextClick(): void {
        this.slick.slick('slickNext');
    }
}
